angular.module('picmonicng').directive('tileDailyGoal', [
  'UserService',
  function (UserService) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/app/directives/tile-daily-goal/tile-daily-goal.html',
      controller: [
        '$rootScope',
        '$scope',
        '$modal',
        'User',
        function ($rootScope, $scope, $modal, User) {
          $scope.UserService = UserService;
          $scope.min = Math.min;

          var labels = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
          var day = new Date().getDay();
          $scope.labels = labels.concat(labels.splice(0, (day + 1) % 7));

          $scope.options = {
            scales: {
              y: {
                min: 0,
                ticks: {
                  precision: 0,
                  beginAtZero: true,
                  stepSize: 5,
                },
              },
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                displayColors: false,
                callbacks: {
                  title: function (tooltipItem) {
                    switch (tooltipItem[0].label) {
                      case 'Su':
                        return 'Sunday';
                      case 'M':
                        return 'Monday';
                      case 'Tu':
                        return 'Tuesday';
                      case 'W':
                        return 'Wednesday';
                      case 'Th':
                        return 'Thursday';
                      case 'F':
                        return 'Friday';
                      case 'Sa':
                        return 'Saturday';
                    }

                    return tooltipItem[0].label;
                  },
                  label: function (context) {
                    return (context.parsed.y ? context.parsed.y : '0') + ' XP';
                  },
                },
              },
            },
          };

          var now = moment();
          var timeDiff =
            moment(now)
              .tz(UserService.user.settings.timezone || moment.tz.guess())
              .endOf('day') - now;
          $scope.hoursLeft = moment.duration(timeDiff).hours() + 4;

          $scope.xps = User.queryv3({
            resource: 'xp',
          });

          $scope.xps.$promise.then(function () {
            $scope.xp = $scope.xps[6].xp;

            $scope.data = {
              labels: $scope.labels,
              datasets: [
                {
                  data: $scope.xps.map(function (x) {
                    return x.xp;
                  }),
                  backgroundColor: 'rgba(255, 150, 0, 0.2)',
                  pointBackgroundColor: 'rgba(255, 150, 0, 1)',
                  pointHoverBackgroundColor: 'rgba(255, 150, 0, 0.8)',
                  borderColor: 'rgba(255, 150, 0, 1)',
                  pointBorderColor: '#fff',
                  pointHoverBorderColor: 'rgba(255, 150, 0, 1)',
                  tension: 0.5,
                  fill: 'origin',
                },
              ],
            };

            const config = {
              type: 'line',
              data: $scope.data,
              options: $scope.options,
            };

            new Chart(document.getElementById('dailyGoalLineChart'), config);
          });

          $rootScope.$on('xp', function (evt, data) {
            $scope.xp = $scope.xp + data.amount;
          });

          $scope.openSettings = function () {
            $modal.open({
              templateUrl: '/templates/modals/daily-goal-settings.html',
              windowClass: 'daily-goal-settings-modal',
              backdropClass: 'above-nav',
              size: 'sm',
              controller: [
                '$scope',
                function ($scope) {
                  $scope.goal = UserService.user.settings.daily_goal || 10;
                  $scope.select = function (goal) {
                    $scope.goal = goal;
                  };

                  $scope.save = function () {
                    if (typeof atlasEvent !== 'undefined') {
                      atlasEvent('click', 'Daily Goal Changed ' + $scope.goal);
                    }
                    UserService.user.settings.daily_goal = $scope.goal;
                    UserService.user.$update().then(function () {
                      $scope.$close();
                    });
                  };
                },
              ],
            });
          };
        },
      ],
    };
  },
]);
